import firebase from '../../firebase'
import { collection, getDocs, orderBy, query, where } from 'firebase/firestore'

const getBugReports = () => {
  const loadBugReportsBasedOnStatus = async (boardId) => {
    const bugReports = {
      'To Do': [],
      'In Progress': [],
      'In Review': [],
      Done: []
    }

    try {
      const bugReportsQuery = query(collection(firebase.db, 'bugReports'), where('boardId', '==', boardId), orderBy('priority'), orderBy('createdAt', 'desc'))
      const querySnapshot = await getDocs(bugReportsQuery)
      querySnapshot.docs.forEach(doc => {
        const data = doc.data()
        const status = data.status || 'To Do'
        if (bugReports[status]) {
          bugReports[status].push({ id: doc.id, ...data })
        }
      })
      return bugReports
    } catch (error) {
      console.log(error)
    }
  }

  const loadAllBugReports = async () => {
    const bugReports = []
    try {
      const bugReportsQuery = query(collection(firebase.db, 'bugReports'), orderBy('createdAt', 'desc'))
      const querySnapshot = await getDocs(bugReportsQuery)
      querySnapshot.docs.forEach(doc => {
        const data = doc.data()
        bugReports.push({ id: doc.id, ...data })
      })
      return bugReports
    } catch (error) {
      console.log(error)
    }
  }

  const loadAllBacklogBugReports = async () => {
    const bugReports = []
    try {
      const bugReportsQuery = query(collection(firebase.db, 'bugReports'), where('boardId', '==', null), orderBy('createdAt', 'desc'))
      const querySnapshot = await getDocs(bugReportsQuery)
      querySnapshot.docs.forEach(doc => {
        const data = doc.data()
        bugReports.push({ id: doc.id, ...data })
      })
      return bugReports
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const loadBugReportsForActiveBoard = async (boardId) => {
    const bugReports = []
    try {
      const bugReportsQuery = query(collection(firebase.db, 'bugReports'), where('boardId', '==', boardId), orderBy('createdAt', 'desc'))
      const querySnapshot = await getDocs(bugReportsQuery)
      querySnapshot.docs.forEach(doc => {
        const data = doc.data()
        bugReports.push({ id: doc.id, ...data })
      })
      return bugReports
    } catch (error) {
      console.log(error)
      return []
    }
  }


  const getActiveBoard = async () => {
    try {
      const boardsQuery = query(collection(firebase.db, 'bugBoards'), where('isActive', '==', true))
      const querySnapshot = await getDocs(boardsQuery)
      let board = {}
      querySnapshot.docs.forEach(doc => {
        board = { id: doc.id, ...doc.data() }
      })
      return board
    } catch (error) {
      console.log(error)
    }
  }


  return { loadBugReportsBasedOnStatus, loadAllBugReports, loadAllBacklogBugReports, getActiveBoard, loadBugReportsForActiveBoard }
}

export default getBugReports
